module.exports = __webpack_public_path__ + "media/images/pic/labels/materials/pera-pera-2-010789d2e58c68dc339dc22ab9613658.jpg";